import { Box, DashboardModule } from '@domain-group/suit-theme'

import useCampaignPortalSyncs from '@hooks/useCampaignPortalSyncs'

import CampaignPortalSyncsTable from './CampaignPortalSyncsTable'

const CampaignPortalSyncs = (props: { campaignId: number }) => {
  const { campaignId } = props

  const campaignPortalSyncPayload = useCampaignPortalSyncs({
    filters: { campaign_id: campaignId },
    performHttpRequests: !!campaignId,
    requestOptions: {
      include_campaign_portal_sync_portal: true,
    },
  })

  const {
    callbacks: { loadMore },
    canLoadMore,
    filteredCampaignPortalSyncs,
    filteredCampaignPortalSyncsCount,
    hasFilteredCampaignPortalSyncs,
    loading,
  } = campaignPortalSyncPayload

  return (
    <DashboardModule
      loading={loading}
      title="Sync Log"
    >
      <Box flexDirection="column">
        {!loading && hasFilteredCampaignPortalSyncs && (
          <CampaignPortalSyncsTable campaignPortalSyncs={filteredCampaignPortalSyncs} />
        )}

        {!loading && !hasFilteredCampaignPortalSyncs && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Portal Syncs
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              When a campaign is synced, the data will appear here.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        <DashboardModule.LoadMoreFooter
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredCampaignPortalSyncsCount}
          loading={loading}
        />
      </Box>
    </DashboardModule>
  )
}

export default CampaignPortalSyncs
